/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */
import { getTelemetryObject, IModuleProps, INodeProps, ITelemetryContent } from '@msdyn365-commerce-modules/utilities';
import * as Msdyn365 from '@msdyn365-commerce/core';
import classnames from 'classnames';
import * as React from 'react';
import LinksComponent from './components/links';
import { IFarmlandsButtonBlockProps } from './farmlands-button-block.props.autogenerated';

export interface IContentBlockViewProps extends IFarmlandsButtonBlockProps<{}> {
    links?: React.ReactNode;
    className?: string;
    contentBlockContainer: IModuleProps;
    detailsContainer: INodeProps;
    contentBlockAnchorTag?: INodeProps;
}
/**
 *
 * FarmlandsButtonBlock component
 * @extends {React.PureComponent<IFarmlandsButtonBlockProps{}>}
 */

class FarmlandsButtonBlock extends React.PureComponent<IFarmlandsButtonBlockProps<{}>> {
    private telemetryContent: ITelemetryContent = getTelemetryObject(
        this.props.context.request.telemetryPageName!,
        this.props.friendlyName,
        this.props.telemetry
    );
    public render(): JSX.Element | null {
        const { links, className } = this.props.config;
        const contentBlockLinks = links && links.length > 0 && (
            <LinksComponent
                {...{
                    links: links,
                    onTextChange: this.handleLinkTextChange,
                    requestContext: this.props.context.request,
                    telemetryContent: this.telemetryContent
                }}
            />
        );

        if (!contentBlockLinks) {
            this.props.context.telemetry.error('Button block content is empty, module wont render.');
            return null;
        }

        const contentBlockviewProps = {
            ...this.props,
            links: contentBlockLinks,
            moduleClass: this.props.config.className,
            contentBlockContainer: {
                moduleProps: this.props,
                className: classnames('farmlands-button-block', className)
            },
            detailsContainer: { className: 'ms-content-block__details' },
            contentBlockAnchorTag: {
                tag: 'a',
                className: 'ms-content-block__link',
                role: 'link'
            }
        };

        return this.props.renderView(contentBlockviewProps) as React.ReactElement;
    }
    /* Handle link text change*/
    public handleLinkTextChange = (linkIndex: number) => (event: Msdyn365.ContentEditableEvent) => {
        if (this.props.config.links && this.props.config.links[linkIndex]) {
            this.props.config.links[linkIndex].linkText = event.target.value;
        }
    }
}

export default FarmlandsButtonBlock;
